import React from 'react';
import { useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import classNames from 'classnames';
import { getQuizStatus } from "examsbook-react-sdk/common";

/**
 * QuizStatus component.
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizStatus = props => {
    const { result, viewMode, questions } = props;
    const classes = useStyles(styles)();
    const t = useTranslations();

    const {
        answered,
        marked,
        notVisited,
        notAnswered,
        notAnsweredVisited
    } = getQuizStatus(questions);
    let rightAns = 0, wrongAns = 0;
    if (result && result.length) {
        result.forEach((sectionResult) => {
            rightAns += sectionResult.rightAns;
            wrongAns += sectionResult.wrongAns;
        });
    }

    return (
        <React.Fragment>
            <div className={[ classes.legendSection ]}>
                <React.Fragment>
                    {!viewMode ?
                        <div className={classes.questionReviewBlock}>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.right)}></span>
                                <span className={classes.label}>{t('Answered')} <span>({answered || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.marked)}></span>
                                <span className={classes.label}>{t('Marked')} <span>({marked || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.notVisited)}></span>
                                <span className={classes.label}>{t('Not Visited')}
                                    <span>({notVisited || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.wrong)}></span>
                                <span className={classes.label}>{t('Not Answered')}
                                    <span>({notAnswered || 0})</span></span>
                            </div>
                            {/* <div className={classes.questionCategory + ' ' + classes.width100}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.markedAnswered)}><i
                                    className="fa fa-check"/></span>
                                <span
                                    className={classes.label}>{t('Marked and Answered')} <span>({markedAndAnswered || 0})</span></span>
                            </div> */}
                        </div> : <div className={classes.questionReviewBlock}>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.right)}></span>
                                <span
                                    className={classes.label}>{t('Right')} <span>({rightAns || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.wrong)}></span>
                                <span
                                    className={classes.label}>{t('Wrong')} <span>({wrongAns || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.notAnswered)}></span>
                                <span
                                    className={classes.label}>{t('Not Answered and Visited')}
                                    <span>({notAnsweredVisited || 0})</span></span>
                            </div>
                            <div className={classes.questionCategory}>
                                <span
                                    className={classNames(classes.background) + ' ' + classNames(classes.notVisited)}></span>
                                <span className={classes.label}>{t('Not Visited')}
                                    <span>({notVisited || 0})</span></span>
                            </div>
                        </div>
                    }
                </React.Fragment>
            </div>
        </React.Fragment>
    );
};

const styles = theme => ({
    legendSection: {
        marginTop: 15,
        paddingLeft: 15,
        paddingRight: 15,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        '@media (max-width: 767px)': {
            position: 'fixed',
            width: '100%',
            marginTop: 0,
            padding: '10px !important',
            background: '#f7fefd',
            zIndex: 999
        }
    },
    background: {
        width: 20,
        height: 20,
        display: 'inline-block',
        borderRadius: '50%'
    },
    right: {
        backgroundColor: '#27ae60',
    },
    notAnswered: {
        backgroundColor: '#FFC658'
    },
    wrong: {
        backgroundColor: '#BF0606'
    },
    notVisited: {
        backgroundColor: '#e1e2e1',
        color: '#000'
    },
    markedAnswered: {
        backgroundColor: '#0b2f8a',
        position: 'relative',
        '& i': {
            position: 'absolute',
            right: -4,
            top: -4,
            color: '#27ae60',
            fontSize: 16,
            '@media (max-width:767px)': {
                top: -8,
                fontSIze: 22
            }
        }
    },
    marked: {
        backgroundColor: '#0b2f8a'
    },
    width100: {
        width: '100%'
    },
    label: {
        color: '#000',
        fontSize: 11,
        fontWeight: 'bold',
        display: 'inline-block',
        textAlign: 'left',
        paddingLeft: 9,
        width: 'calc(100% - 30px)',
        '@media (max-width: 767px)': {
            width: '100%',
            paddingLeft: 0,
            paddingTop: 6,
            position: 'relative',
            '& > span': {
                position: 'absolute',
                top: -19,
                left: 25,
                fontSize: 14
            }
        }
    },
    questionReviewBlock: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 0,
        justifyContent: 'space-between',
    },
    questionCategory: {
        marginBottom: 15,
        display: 'flex',
        alignItems: 'center',
        width: '50%',
        '@media (max-width:767px)': {
            width: 'auto',
            flexDirection: 'column',
            alignItems: 'flex-start',
            flex: 1
        }
    }

});

export default QuizStatus;
